<template>
    <div :class="['review']">
        <div class="review__author">
            <div class="review__author-avatar">
                <img :src="photo.src" :alt="photo.alt" :title="photo.title">
            </div>
            <div class="review__info">
                <span class="review__author-name mr-1">{{ author }}</span>
                <span v-if="company " class="review__author-descr">{{ company }}</span>
                <br v-if="$mqAbove('MOBILE')">
                <span v-if="position" class="review__author-position">{{ position }}</span>
            </div>
            <div class="review__date" v-if="date">
                {{ date }}
            </div>
        </div>
        <div class="review__text">
            {{ text }}
        </div>

        <div class="review__footer" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>

/**
 * https://i.imgur.com/Ac3893k.png
 * */

export default {
    name: 'ReviewsSmallCard',
    props: {
        author: {
            type: String,
            default: '',
        },
        company: {
            type: String,
            default: '',
        },
        position: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: '',
        },
        photo: {
            type: String,
            default: '',
        },
    },
    setup: (props, ctx) => {

        return {}
    },
}
</script>

<style lang="scss" scoped>

</style>
